import { useState, useContext, useEffect, useMemo } from "react";
import styles from "./FilterMenu.module.scss";
import { AppContext } from "../../AppContext";
import SearchList from "../../utils/components/SearchList/SearchList";
import { fetchFilterPreferences, exportExcel } from "../../api";
import { clamp } from "../../utils/genericUtils";
import LoadingSpinner from "../Loading/LoadingSpinner";

const FilterMenu = ({
  filter = {
    start_date: "",
    end_date: "",
    user_ids: [],
    category_ids: [],
    statuses: [],
    offset: 0,
  },
  setFilter = (val) => {},
  clearFilter = () => {},
}) => {
  const {
    user,
    allUsers,
    allCategories,
    statusChoices,
    statusDict,
    tasksQueryData,
  } = useContext(AppContext);

  const [saveAsExcelLoading, setSaveAsExcelLoading] = useState(false);

  const clearFilters = () => {
    clearFilter();
  };

  const changeFilter = (newFilter) => {
    if (newFilter.offset === filter.offset) {
      newFilter.offset = 0;
    }
    setFilter(newFilter);
  };

  const handleExport = () => {
    setSaveAsExcelLoading(true);
    exportExcel({
      data: {
        users: filter.user_ids,
        categories: filter.category_ids,
        start_date: filter.start_date,
        end_date: filter.end_date,
        statuses: filter.statuses,
      },
    }).finally(() => {
      setSaveAsExcelLoading(false);
    });
  };

  const handleCheckboxChange = (e, value, field_name) => {
    const newValues = [...filter[field_name]];
    if (e.target.checked) {
      newValues.push(value);
    } else {
      const index = newValues.indexOf(value);
      if (index > -1) {
        newValues.splice(index, 1);
      }
    }
    let prevFilter = { ...filter };
    prevFilter[field_name] = newValues;
    changeFilter(prevFilter);
  };

  const currentPage = useMemo(() => {
    if (!tasksQueryData || !tasksQueryData.limit) return 0;
    const result = filter.offset / tasksQueryData.limit + 1;
    return result;
  }, [tasksQueryData]);

  useEffect(() => {
    fetchFilterPreferences(user.id).then((res) => {
      changeFilter(res.filter_data);
    });
  }, []);

  return (
    <>
      <div className={styles.container}>
        <div className={styles.title_container}>
          <h2>Filtri avanzati</h2>
          <button
            className={styles.delete_filters_button}
            onClick={clearFilters}
          >
            Cancella filtri
          </button>
          <div
            style={{
              marginLeft: "auto",
              display: "flex",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            {tasksQueryData && (
              <div
                style={{ display: "flex", gap: ".5rem", alignItems: "center" }}
              >
                <label>Pagina:</label>
                <input
                  type="number"
                  style={{ maxWidth: "4rem" }}
                  onChange={(e) => {
                    changeFilter({
                      ...filter,
                      offset: clamp(
                        (e.target.value - 1) * tasksQueryData.limit,
                        0,
                        Math.floor(
                          tasksQueryData.count / tasksQueryData.limit
                        ) * tasksQueryData.limit
                      ),
                    });
                  }}
                  value={currentPage}
                />
                <span>{`/ ${Math.ceil(
                  tasksQueryData.count / tasksQueryData.limit
                )}`}</span>
              </div>
            )}
            <button
              className={"button_var1 " + styles.excel_button}
              onClick={() => handleExport()}
            >
              {!saveAsExcelLoading ? (
                "Salva in formato Excel"
              ) : (
                <LoadingSpinner />
              )}
            </button>
          </div>
        </div>
        <div className={styles.date_container}>
          <label>Da </label>
          <input
            type="date"
            value={filter.start_date}
            onChange={(e) =>
              changeFilter({ ...filter, start_date: e.target.value })
            }
          ></input>
          <label> A </label>
          <input
            type="date"
            value={filter.end_date}
            onChange={(e) =>
              changeFilter({ ...filter, end_date: e.target.value })
            }
          ></input>
        </div>
        <div className={styles.search_lists_container}>
          <div className={styles.search_list_container}>
            <h3>Lista Lavoratori</h3>
            <SearchList
              containerClassName={styles.search_list_content}
              selectedItems={filter.user_ids}
              onCheckboxChange={(e, item) => {
                handleCheckboxChange(e, item, "user_ids");
              }}
            >
              {allUsers
                .filter((user) => user.worker)
                .map((user, idx) => {
                  return (
                    <option key={idx} value={user.id}>
                      {user.last_name + " " + user.first_name}
                    </option>
                  );
                })}
            </SearchList>
          </div>
          <div className={styles.search_list_container}>
            <h3>Lista Categorie</h3>
            <SearchList
              containerClassName={styles.search_list_content}
              selectedItems={filter.category_ids}
              onCheckboxChange={(e, item) => {
                handleCheckboxChange(e, item, "category_ids");
              }}
            >
              {allCategories.map((category, idx) => {
                return (
                  <option key={idx} value={category.id}>
                    {category.name}
                  </option>
                );
              })}
            </SearchList>
          </div>
          <div className={styles.search_list_container}>
            <h3>Lista Status</h3>
            <SearchList
              containerClassName={styles.search_list_content}
              selectedItems={filter.statuses}
              onCheckboxChange={(e, item) => {
                handleCheckboxChange(e, item, "statuses");
              }}
            >
              {statusChoices.map((statusChoice, idx) => {
                return (
                  <option key={idx} value={statusChoice.value}>
                    {statusDict[statusChoice.value]}
                  </option>
                );
              })}
            </SearchList>
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterMenu;
